var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComboCenterBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M18 24H2C1.45 24 1 23.55 1 23V14.5C1 12.845 2.345 11.5 4 11.5H16C17.655 11.5 19 12.845 19 14.5V23C19 23.55 18.55 24 18 24Z",
    fill: "#D0D7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M7.5002 3.54995H6.5002C6.0602 3.54995 5.7002 3.18995 5.7002 2.74995C5.7002 2.30995 6.0602 1.94995 6.5002 1.94995H7.5002C7.9402 1.94995 8.3002 2.30995 8.3002 2.74995C8.3002 3.18995 7.9402 3.54995 7.5002 3.54995Z",
    fill: "#AFB8C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M11.5002 6.29995H6.5002C6.0602 6.29995 5.7002 5.93995 5.7002 5.49995C5.7002 5.05995 6.0602 4.69995 6.5002 4.69995H11.5002C11.9402 4.69995 12.3002 5.05995 12.3002 5.49995C12.3002 5.93995 11.9402 6.29995 11.5002 6.29995Z",
    fill: "#AFB8C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M13.5002 3.54995H10.0002C9.5602 3.54995 9.2002 3.18995 9.2002 2.74995C9.2002 2.30995 9.5602 1.94995 10.0002 1.94995H13.5002C13.9402 1.94995 14.3002 2.30995 14.3002 2.74995C14.3002 3.18995 13.9402 3.54995 13.5002 3.54995Z",
    fill: "#AFB8C1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M11.75 18.75H5.25C4.835 18.75 4.5 18.415 4.5 18C4.5 17.585 4.835 17.25 5.25 17.25H11.75C12.165 17.25 12.5 17.585 12.5 18C12.5 18.415 12.165 18.75 11.75 18.75Z",
    fill: "#AFB8C1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M14.75 22H5.25C4.835 22 4.5 21.665 4.5 21.25C4.5 20.835 4.835 20.5 5.25 20.5H14.75C15.165 20.5 15.5 20.835 15.5 21.25C15.5 21.665 15.165 22 14.75 22Z",
    fill: "#AFB8C1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M5.735 7.19993C5.485 6.86993 5.015 6.79993 4.685 7.04993L0.299999 10.3399C0.109999 10.4799 0 10.7049 0 10.9399C0 11.5599 0.705001 11.9099 1.2 11.5399L5.585 8.24993C5.915 7.99993 5.985 7.52993 5.735 7.19993Z",
    fill: "#D0D7DE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M14.1944 6.08484C13.8644 5.83484 13.3944 5.90484 13.1444 6.23484C12.8944 6.56484 12.9644 7.03484 13.2944 7.28484L18.7994 11.5398C19.2944 11.9098 19.9994 11.5598 19.9994 10.9398C19.9994 10.7048 19.8894 10.4798 19.6994 10.3398L14.1944 6.08484Z",
    fill: "#D0D7DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComboCenterBottom);
export default __webpack_public_path__ + "static/media/combo-center-bottom.e835653f0a51bb0db721f4413bb75d25.svg";
export { ForwardRef as ReactComponent };